import { useAuth } from '@/hooks/useAuth'
import { KnowledgeDialog } from '@/components/settings/Settings'

// /admin/knowledge — KnowledgeDialog v2 をフルページ（AdminLayout の主画面）として描画。
// asPage=true でモーダル枠を外す。アコーディオン展開・折り畳みは内部 state で完結し、
// 画面遷移は発生しないので onClose は no-op で渡す。
export default function KnowledgeManagement() {
  const { token } = useAuth()
  if (!token) return null
  return <KnowledgeDialog idToken={token} onClose={() => {}} asPage />
}
